<template>
  <el-dialog :visible.sync="dialogVisible" width="50%" :show-close="false" @close="handleClose" :close-on-click-modal="false">
    <div class="padding-bottom-120">
      <div class="padding-lr-30 flex justify-between align-center solid-bottom h-70 text-main">
        <span class="text-18">{{ progress }}</span>
        <span class="text-20">{{ title }}</span>
        <i class="el-icon-close" @click="handleClose"></i>
      </div>
      <div class="text-center">
        
        <div class="icon-container">
          <img src="@/assets/icon33.png" class="completed-icon" v-if="showIcon" />
        </div>
        <div class="padding-tb-40 text-24 text-000-color">
          {{ message }}
        </div>
        <el-button type="primary" class="custom-button-common" :disabled="isStartingTest" @click="handleStartTest">
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "LearningCompletedDialog",
  data() {
    return {
      isStartingTest: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    progress: {
      type: [String, Number],
      default: "1"
    },
    title: {
      type: String,
      default: "2"
    },
    message: {
      type: String,
      default: "已完成本单元学习"
    },
    buttonText: {
      type: String,
      default: "开始测试"
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.isStartingTest = false;
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleStartTest() {
      if (this.isStartingTest) return;
      this.isStartingTest = true;
      this.$emit('start-test');
    }
  }
};
</script>
<style scoped>
.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>
<style scoped lang="scss">
::v-deep {

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }

  .el-dialog {
    border-radius: 30px;
    background: linear-gradient(#ffffff 15%, #e8edff 100%);
    box-shadow: none;
  }
}

.solid-bottom {
  border-bottom: 1px solid #2342c9;
}

.el-icon-close {
  color: #2342c9 !important;
}

.icon-container {
  padding-top: 60px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.completed-icon {
  width: 120px;
  height: 120px;
}
</style>
